import { API_PATH, GLOBAL_ENVIRONMENT } from '../constants/api-path';
import { GLOBAL_DEFAULT } from '../constants/global';
import storage from '../helpers/storage';
import httpClient from './interceptor';

const commonService = {

    getCountries: (): Promise<any> => {
		return httpClient.get(API_PATH.COMMON.COUNTRIES);
	},
    getMasterEnvironment: (): Promise<any> => {
        return httpClient.get(GLOBAL_ENVIRONMENT);
    },

    getSalesChannel: (): Promise<any> => {
        return httpClient.get(API_PATH.COMMON.SALES_CHANNEL);
    },

    getStates: (countryId: number): Promise<any> => {
		return httpClient.get(API_PATH.COMMON.STATES + countryId);
	},

    getShippingProviders: (): Promise<any> => {
        return httpClient.get(API_PATH.SHIPPINGPROVIDER.LISTING);
    },

    getWareHouseList: (type: string = ''): Promise<any> => {
        const cached = storage.getWarehouseList(type);
        if (cached) return Promise.resolve({ data: cached });
        return commonService.fetchAndStoreWarehouseList(type);
    },

    fetchAndStoreWarehouseList: (type: string = ''): Promise<any> => {
        const query = type !== '' ? '?type=' + type : '';
        return httpClient.get(API_PATH.COMMON.WAREHOUSE_LIST + query).then((response: any) => {
            if (response?.data) storage.setWarehouseList(type, response.data);
            return response;
        });
    },

    // Warehouse list is cached per `type` (see storage.setWarehouseList/getWarehouseList).
    // Any warehouse write (add/edit/status change) must invalidate every cached type bucket,
    // not just the ones this module happens to know about, so we clear by key prefix instead
    // of refetching a hardcoded list of types — this self-heals for any type value in use now
    // or added later. Consumers naturally repopulate their bucket on next read (cache miss).
    invalidateWarehouseListCache: (): void => {
        storage.clearWarehouseListCache();
    },

    getWarehouseProductList: (warehouseId: number, payloadData: any): Promise<any> => {
        return httpClient.post(API_PATH.COMMON.WAREHOUSE_PRODUCT_LIST + warehouseId, {
            page: payloadData.page, 
            search: payloadData.search,
            row_per_page: GLOBAL_DEFAULT.ROW_PER_PAGE_100
        });
    },

    getWarehouseProductByIds: (warehouseId: number, productIds: number[]): Promise<any> => {
        return httpClient.post(API_PATH.COMMON.WAREHOUSE_PRODUCT_LIST + warehouseId, {
            product_ids: productIds
        });
    },

    getUsersList: (): Promise<any> => {
		return httpClient.get(API_PATH.COMMON.BUYER_LIST);
	},

    getBrandsList: (): Promise<any> => {
		return httpClient.get(API_PATH.COMMON.BRAND_LIST);
	},

    getProductsList: (): Promise<any> => {
		return httpClient.get(API_PATH.COMMON.PRODUCT_LIST);
	},

    getProductsListNew: (payloadData: any): Promise<any> => {
		return httpClient.post(API_PATH.COMMON.PRODUCT_LIST_NEW, payloadData);
	},

    getCarriersList: (): Promise<any> => {
        const cached = storage.getCarrierList();
        if (cached) return Promise.resolve({ data: cached });
        return commonService.fetchAndStoreCarrierList();
    },

    fetchAndStoreCarrierList: (): Promise<any> => {
        return httpClient.get(API_PATH.COMMON.CARRIER_LIST).then((response: any) => {
            if (response?.data) storage.setCarrierList(response.data);
            return response;
        });
    },

    syncCarrierConnected: (): Promise<any> => {
        return httpClient.get(API_PATH.SHIPPINGPROVIDER.SYNC_CARRIER_CONNECTED);
    }
}

export default commonService;